import { useEffect, useRef, useState } from "react"
import FileGridIcon from "../../assets/icons/file_grid.svg"
import "./styles.scss"
import { blobToBase64, sendFileToFirebase } from "../../core/utils/hooks/uploadItem"
import { Button, ButtonLoader } from "../Button"
import { IoClose } from "react-icons/io5"
import posterVideo from '../../assets/img/assistance-chat-background.png'
import { BsFiletypeDoc, BsFiletypeDocx } from "react-icons/bs"

export const FileInput = ({ value, handleChangeFile = () => { } }) => {
  const fileInputRef = useRef(null)

  const handleClick = () => {
    fileInputRef.current.click()
  }

  const handleChange = async (event) => {
    const fileUploaded = event.target.files[0]
    const fileLink = await processFile(fileUploaded)
    handleChangeFile(fileLink)
  }

  const processFile = async (file) => {
    try {
      const base64 = await blobToBase64(file)
      return await sendFileToFirebase(base64, file)
    } catch (error) {
      console.error("Erro ao processar arquivo:", error)
      throw error
    }
  }

  return (
    <div className="file_input__container">
      <button className="button-upload" onClick={handleClick}>
        {value ? (
          <>
            <span>Upload concluído, você pode alterar o arquivo clicando abaixo.</span>
            <div className="file_upload__content">
              <img src={FileGridIcon} alt="Upload do arquivo" />
              <span>Upload de novo arquivo</span>
            </div>
          </>
        ) : (
          <>
            <span>Faça o upload do arquivo.</span>
            <div className="file_upload__content">
              <img src={FileGridIcon} alt="Upload do arquivo" />
              <span>Upload do arquivo</span>
            </div>
          </>
        )}
      </button>
      <input ref={fileInputRef} type="file" onChange={handleChange} style={{ display: "none" }} />
    </div>
  )
}

export const InputFileWithPreview = ({
  handleChangeFile = () => { },
  handleRemoveFile = () => { },
  uploaded = [],
  clearPreview = false,
  isDisabled = false,
  name,
  accept = ".jpg, .jpeg, .png, .mp4, .webm, .webp, .ogg",
  loadingProcessImage = false,
  id = "input-file",
  isMultiple = false,
}) => {
  const fileInputRef = useRef(null);
  const [mediaPreviews, setMediaPreviews] = useState([]);
  const [files, setFiles] = useState([]);
  const [previousUploaded, setPreviousUploaded] = useState([]);
  const [removedFiles, setRemovedFiles] = useState(false)

  const resetPreview = () => {
    setFiles([]);
    setMediaPreviews([]);
    setPreviousUploaded([]);
    setRemovedFiles(true)
    fileInputRef.current.value = null;
  }

  useEffect(() => {
    if (clearPreview) {
      resetPreview();
    }
  }, [clearPreview]);

  useEffect(() => {
    if (loadingProcessImage) return;

    const hasNewUploads = uploaded?.length > 0 && uploaded?.length >= mediaPreviews?.length;
    const noRemovals = !removedFiles;
    const isFirstLoad = previousUploaded.length === 0;

    if (hasNewUploads && noRemovals && isFirstLoad) {
      setMediaPreviews(uploaded);
      setPreviousUploaded(uploaded);
      setRemovedFiles(false);
    }
  }, [uploaded, mediaPreviews.length, removedFiles, previousUploaded.length, loadingProcessImage, clearPreview]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleChange = async (e) => {
    const selectedFiles = e.target.files;

    if (selectedFiles.length > 0) {
      const newFiles = [];
      const newMediaPreviews = [];

      await Promise.all(
        Array.from(selectedFiles).map((file) =>
          new Promise((resolve) => {
            const reader = new FileReader();

            reader.onload = (e) => {
              newMediaPreviews.push(e.target.result);
              newFiles.push(file);
              resolve();
            };

            reader.readAsDataURL(file);
          })
        )
      );

      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      setMediaPreviews((prevPreviews) => [
        ...newMediaPreviews,
        ...prevPreviews
      ]);
    }
  };

  const handleRemoveMediaPreview = () => {
    handleChangeFile({
      target: {
        files: [],
        remove: true
      }
    })
    setFiles([]);
    setMediaPreviews([]);
    setRemovedFiles(true)
    fileInputRef.current.value = null;
  };

  const handleRemoveMedia = (index, e) => {
    e.stopPropagation();

    setMediaPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleUpload = async () => {
    if (files.length > 0) {
      await handleChangeFile({
        target: {
          files: files,
          name: fileInputRef.current.name,
        }
      });
      resetPreview();
    }
  };

  const isVideo = (url) => {
    return /(\.mp4|\.webm|\.ogg)/i.test(url) || url.includes("video");
  };

  const isImage = (url) => {
    return /(\.jpeg|\.jpg|\.png)/i.test(url) || url.includes("image");
  };

  const isFirebasUrl = (url) => {
    return /(\.mp4|\.webm|\.ogg|\.jpeg|\.jpg|\.png)/i.test(url)
  };

  return (
    <div className="file_input__container">
      <button className="button-upload" onClick={handleClick} disabled={loadingProcessImage}>
        <span
          title={
            mediaPreviews.length > 0
              ? `Mídia adicionada (${mediaPreviews.length}), para adicionar mais clique aqui`
              : "Clique para adicionar"
          }>
          {mediaPreviews.length > 0
            ? `Mídia adicionada (${mediaPreviews.length}), para adicionar mais clique aqui`
            : "Faça o upload da mídia"}
        </span>
        <div className="file_upload-media__content" title="Clique para adicionar">
          {mediaPreviews.length > 0 ? (
            <div className="media-grid">
              {mediaPreviews.map((preview, index) => (
                <div key={index} className="preview-media">
                  <div className="media-overlay">
                    {isVideo(preview) ? (
                      <video
                        title={isFirebasUrl(preview) ? "Vídeo de evidencia já adicionado" : ""}
                        src={preview}
                        className="video-preview"
                        poster={posterVideo}
                        controls
                      />
                    ) : isImage(preview) ? (
                      <img
                        title={isFirebasUrl(preview) ? "Imagem de evidencia já adicionada" : ""}
                        src={preview}
                        alt={`Preview ${index}`}
                        className="file-preview"
                      />
                    ) :
                      <div className="file-preview doc-preview">
                        <BsFiletypeDoc />
                      </div>}
                    {!isFirebasUrl(preview) && !loadingProcessImage && (
                      <button
                        className="remove-media-button"
                        title="Clique para excluir"
                        onClick={(e) => handleRemoveMedia(index, e)}>
                        <IoClose />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <>
              <img src={FileGridIcon} alt="Upload da mídia" />
              <span>Upload da mídia</span>
            </>
          )}
        </div>
      </button>
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleChange}
        style={{ display: "none" }}
        id={id}
        name={name}
        accept={accept}
        multiple={isMultiple}
        disabled={isDisabled}
      />

      {mediaPreviews.length > 0 && (
        <div className="button-upload-confirm">
          {!loadingProcessImage && <Button label="Remover" variant="ghost" handleClick={handleRemoveMediaPreview} />}
          <ButtonLoader label="Upload" loading={loadingProcessImage} handleClick={handleUpload} />
        </div>
      )}
    </div>
  )
};








